'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var NextRouter = require('next/router');
var NextLink = require('next/link');
var React = require('react');
var history$1 = require('history');
var reactRouter = require('react-router');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var NextRouter__default = /*#__PURE__*/_interopDefaultLegacy(NextRouter);
var NextLink__default = /*#__PURE__*/_interopDefaultLegacy(NextLink);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var history = history$1.createMemoryHistory();
history.listen(function (location, action) {
  console.group();
  console.log("The current URL, is ".concat(location.pathname).concat(location.search).concat(location.hash));
  console.log("The last navigation action was ".concat(action));
  console.groupEnd();
});
var Router = {
  push: function push(_url, _as) {
    if (typeof _url === 'string') {
      return history.push(_url);
    } else if (typeof _as === 'string') {
      return history.push(_as);
    } else {
      var _ref = _as || _url,
          pathname = _ref.pathname,
          query = _ref.query;

      return history.push(Object.assign({
        pathname: pathname
      }, query && {
        search: '?' + new URLSearchParams(query).toString()
      }));
    }
  },
  replace: function replace(_url, _as) {
    if (typeof _url === 'string') {
      return history.replace(_url);
    } else if (typeof _as === 'string') {
      return history.replace(_as);
    } else {
      var _ref2 = _as || _url,
          pathname = _ref2.pathname,
          query = _ref2.query;

      return history.replace(Object.assign({
        pathname: pathname
      }, query && {
        search: '?' + new URLSearchParams(query).toString()
      }));
    }
  }
};

var withRouter = function withRouter(Component) {
  var SomeComp = function SomeComp(props) {
    var params = props.match.params,
        _props$location = props.location,
        search = _props$location.search,
        pathname = _props$location.pathname;
    var parsedSearch = {};
    new URLSearchParams(search).forEach(function (value, key) {
      parsedSearch[key] = value;
    });
    var router = {
      query: Object.assign({}, params, parsedSearch),
      push: Router.push,
      replace: Router.replace,
      route: pathname
    };
    return /*#__PURE__*/React__default['default'].createElement(Component, _extends({
      router: router
    }, props));
  };

  return reactRouter.withRouter(SomeComp);
};

var Link = function Link(_ref3) {
  var _url = _ref3.href,
      _as = _ref3.as,
      children = _ref3.children,
      _onClick = _ref3.onClick;
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, React__default['default'].Children.map(children, function (child) {
    if (React__default['default'].isValidElement(child)) {
      if (child.type !== 'a') {
        return React__default['default'].cloneElement(child);
      } else {
        return React__default['default'].cloneElement(child, {
          onClick: function onClick(e) {
            e.preventDefault();

            if (_onClick) {
              _onClick({
                _url: _url,
                _as: _as
              });
            } else {
              // options should be read to use PUSH/REPLACE
              Router.replace(_url, _as); // options should be read to use PUSH/REPLACE
            }
          },
          href: _url
        });
      }
    }

    return child;
  }));
};

var _process, _process$env, _process$env$HOSTNAME;
var isNextProject = typeof process !== 'undefined' && ((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : (_process$env$HOSTNAME = _process$env.HOSTNAME) === null || _process$env$HOSTNAME === void 0 ? void 0 : _process$env$HOSTNAME.includes('trypico'));


var Router$1;
exports.history = null;

if (isNextProject) {
  exports.withRouter = NextRouter.withRouter;
  exports.Link = NextLink__default['default'];
  Router$1 = NextRouter__default['default'];
} else {
  exports.withRouter = withRouter;
  exports.Link = Link;
  Router$1 = Router;
  exports.history = history;
}
var Router$2 = Router$1;

exports.default = Router$2;
